import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcPharma = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6666 2.74999C14.6666 2.50688 14.57 2.27372 14.3981 2.10181C14.2262 1.92991 13.993 1.83333 13.7499 1.83333H8.24992C8.0068 1.83333 7.77365 1.92991 7.60174 2.10181C7.42983 2.27372 7.33325 2.50688 7.33325 2.74999V7.33333H2.74992C2.5068 7.33333 2.27365 7.42991 2.10174 7.60181C1.92983 7.77372 1.83325 8.00688 1.83325 8.24999V13.75C1.83325 13.9931 1.92983 14.2263 2.10174 14.3982C2.27365 14.5701 2.5068 14.6667 2.74992 14.6667H7.33325V19.25C7.33325 19.4931 7.42983 19.7263 7.60174 19.8982C7.77365 20.0701 8.0068 20.1667 8.24992 20.1667H13.7499C13.993 20.1667 14.2262 20.0701 14.3981 19.8982C14.57 19.7263 14.6666 19.4931 14.6666 19.25V14.6667H19.2499C19.493 14.6667 19.7262 14.5701 19.8981 14.3982C20.07 14.2263 20.1666 13.9931 20.1666 13.75V8.24999C20.1666 8.00688 20.07 7.77372 19.8981 7.60181C19.7262 7.42991 19.493 7.33333 19.2499 7.33333H14.6666V2.74999Z",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcPharma;
